import { Model } from "@/models/base/model";
import { _$t } from "@/utils/i18n";

export class Treatment extends Model {
  private baseUrl = "/cms/api/my-record/treatment"; // ベースURL
  // コンストラクタ
  constructor(params: any = {}) {
    super(params);
    this.url = this.baseUrl;
    this.validation = this.getValidationSchema();
    this.labels = this.getValidationLabels();
  }

  // 治療一覧画面情報取得
  async getPageData(): Promise<any> {
    this.url = this.baseUrl;
    return await super.fetch();
  }

  // 治療の詳細を取得
  async getData(
    treatment: {
      userTreatmentId: number;
      subNumber: number;
    } | null
  ): Promise<any> {
    this.url = `${this.baseUrl}/get-detail`;
    if (treatment) {
      const { userTreatmentId, subNumber } = treatment;
      const searchParams = new URLSearchParams();
      if (userTreatmentId) {
        searchParams.append("user_treatment_id", userTreatmentId.toString());
      }
      if (subNumber) {
        searchParams.append("sub_number", subNumber.toString());
      }
      this.url = `${this.url}?${searchParams.toString()}`;
    }
    return await super.fetch();
  }

  // 保存処理
  async save(): Promise<any> {
    this.url = `${this.baseUrl}/save`;
    return await super.save({}, "POST");
  }

  // 削除処理
  async delete(userTreatmentId: number): Promise<any> {
    this.url = `${this.baseUrl}/delete`;
    return await super.save({ userTreatmentId }, "DELETE");
  }

  // 治療履歴修得
  async getHistory(limitDate?: string): Promise<any> {
    this.url = `${this.baseUrl}/get-history`;
    if (limitDate) {
      this.url = `${this.url}?limit_date=${limitDate}`;
    }
    return await super.fetch();
  }

  async checkDiseaseTreatment(diseaseCode: string): Promise<any> {
    this.url = `${this.baseUrl}/check-disease-treatment?disease_code=${diseaseCode}`;
    return await super.fetch();
  }

  // バリデーションルール
  getValidationSchema() {
    return {
      // 治療対象の病名
      diseaseCode: {
        type: "string",
        required: false,
        pattern: "number",
      },
      // 治療
      treatmentOptionId: {
        type: "integer",
        required: true,
      },
      // 具体的な治療や薬の名前
      detail: {
        required: false,
        type: "string",
        maxLength: 100,
      },
      // 治療効果
      effectOptionId: {
        type: "integer",
        required: false,
      },
      // 中断・再開理由
      burden: {
        required: false,
        type: "string",
        maxLength: 200,
      },
      // 中断・再開理由
      startDate: {
        required: false,
        type: "string",
        pattern: "date",
      },
      // 中断・再開理由
      updateDate: {
        required: false,
        type: "string",
        pattern: "date",
      },
    };
  }

  // バリデーションラベル
  getValidationLabels() {
    return {
      diseaseCode: _$t("treatment_label_disease_name"),
      treatmentOptionId: _$t("treatment_label_treatment"),
      detail: _$t("treatment_label_details"),
      effectOptionId: _$t("treatment_label_treatment_effect"),
      burden: _$t("treatment_label_reason"),
      startDate: _$t("treatment_label_start_date"),
      updateDate: _$t("treatment_label_date"),
    };
  }
}
